// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"df253939","703":"ce9bfd21"}[chunkId] + ".chunk.js";
};